export const ENGLISH_LANGUAGE_CODE = "en";
export const UNREDACTED_ENGLISH_LANGUAGE_CODE = "en-unredacted";

interface ToggleItem {
    value: string;
    element: string;
}

interface HasLanguageCode {
    languageCode: string;
}

export function getTranslatedLanguageCode(
    languageSources?: HasLanguageCode[],
): string | undefined {
    const codes = languageSources?.map((item) => item.languageCode);
    if (!codes?.includes(ENGLISH_LANGUAGE_CODE)) return undefined;
    return codes.find(
        (languageCode) =>
            languageCode !== ENGLISH_LANGUAGE_CODE &&
            languageCode !== UNREDACTED_ENGLISH_LANGUAGE_CODE,
    );
}

export function getTranslationToggleItems(
    translationLanguageCode?: string,
): ToggleItem[] {
    if (translationLanguageCode === undefined) return [];
    return [
        {
            value: ENGLISH_LANGUAGE_CODE,
            element: "English",
        },
        {
            value: translationLanguageCode as string,
            element: "Original",
        },
    ];
}

export function getRedactionToggleItems(): ToggleItem[] {
    return [
        {
            value: ENGLISH_LANGUAGE_CODE,
            element: "English",
        },
        {
            value: UNREDACTED_ENGLISH_LANGUAGE_CODE,
            element: "Unredacted",
        },
    ];
}
